module.exports = __webpack_public_path__ + "static/media/Boundary_South.0e774ef9.jpg";